module.exports = __webpack_public_path__ + "static/media/UserNew.b776f7d3.svg";